import { Sector } from '../api/index'

/*
* If there are values in an enum that are casted to any ts (current 3.0.1) generates
* duplicate object entries in the generated javascript-code with the difference being
* that key-value are inverted
*
* So just running Object.keys on this enum won't return just the keys it will actually
* return an array of all keys AND all values because the swagger-generated code defines
* all enum values casted to any.
* */

export const sectors: Sector [] = [
  Sector.BusinessAdministration,
  Sector.PublicAdministration,
  Sector.CustomerService,
  Sector.Audiovisual,
  Sector.BeautyWellness,
  Sector.Sales,
  Sector.Logistics,
  Sector.Design,
  Sector.Education,
  Sector.Coaching,
  Sector.Finance,
  Sector.It,
  Sector.Engineering,
  Sector.Construction,
  Sector.Research,
  Sector.Justice,
  Sector.Music,
  Sector.Manufacturing,
  Sector.Machinery,
  Sector.Other,
  Sector.Health,
  Sector.Security,
  Sector.Transportation,
  Sector.Tourism,
]



// WEBPACK FOOTER //
// ./src/project-utils/hardcoded.ts